import { useSelector } from 'react-redux';
import Account from 'static/models/Account';

import { RootState } from '../redux/root';

export const useAvailableAccounts = (): Account[] => {
    return useSelector((state: RootState) => state.availableAccounts);
};
